import React from 'react';
import Header from './components/Header';
import Home from './pages/Home';
import Trading from './pages/Trading';
import AI from './pages/AI';
import RenewableEnergy from './pages/RenewableEnergy';
import Technology from './pages/Technology';
import Battery from './pages/Battery';
import Services from './pages/Services';
import { Routes, Route } from 'react-router-dom';

const App: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ai" element={<AI />} />
        <Route path="/renewable-energy" element={<RenewableEnergy />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/battery" element={<Battery />} />
        <Route path="/services" element={<Services />} />
        <Route path="/trading" element={<Trading />} />
        <Route path="*" element={<div>Page Not Found</div>} />
      </Routes>
    </div>
  );
};

export default App;
